import { apiClient } from '../client'
import type { DashboardResponse } from '../../app/modules/types/dashboard'
import type { MultiOrgDashboardResponse } from '../../app/modules/types/multi-org-dashboard'

/**
 * Dashboard API endpoints
 */
export const dashboardApi = {
  /**
   * Get dashboard data
   */
  getData: async (): Promise<DashboardResponse> => {
    const { data } = await apiClient.get('/dashboard/')
    return data
  },

  /**
   * Group board — headline, exception cards, company coverage, are-we-winning,
   * estate growth, and the truncation notice. ONE request fills the whole board.
   */
  getMultiOrgData: async (): Promise<MultiOrgDashboardResponse> => {
    const { data } = await apiClient.get('/multi-org-dashboard/')
    return data
  },
}
